export default function Footer() {
  return (
    <footer>
      <hr className="mt-0 mb-5"></hr>
      <p>
        When choosing great flavor combinations for smoking meat, one thought to
        consider is the potency of various smoking woods. It helps to look at
        the intensity of smoking woods on a scale of mild to strong. You want
        the wood that you select to harmonize with the type of meat you will be
        smoking and bear in mind that you do not want to over-smoke your meats.
      </p>
      <hr className="mt-5"></hr>
    </footer>
  );
}
